import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const VerifikasiEmailHero = () => {
    return (
        <CheckCircleIcon
            htmlColor="#45A779"
            sx={{ width: "100px", height: "100px" }}
        />
    );
};

export default VerifikasiEmailHero;
